import { createRouter, createWebHistory } from 'vue-router'
import MainPage from '@/components/pages/Main-page'
import NotFound from '@/components/pages/NotFound'

const routes = [
  {
    path: '/',
    name: 'main',
    component: MainPage
  },
  {
    path: '/catalog',
    name: 'Catalog-page',
    component: ()=> import('@/components/pages/Catalog-page')
  },
  {
    path: '/confidential',
    name: 'Confidential-page',
    component: ()=> import('@/components/pages/Confidential-page')
  },
  {
    component:()=> import('@/admin/Admin-main-page'),
    name: 'admin',
    path: '/admin'
  },
  {
    component:()=> import('@/admin/Pages/Site-edit'),
    name: 'site-edit',
    path: '/site-edit'
  },
  {
    component:()=> import('@/admin/Pages/Articles-page'),
    name: 'admin-articles',
    path: '/admin-articles'
  },
  {
    component:()=> import('@/admin/Pages/Promo-page'),
    name: 'admin-promo',
    path: '/admin-promo'
  },
  {
    path: '/admproduct',
    name: 'admproduct',
    component:()=> import('@/admin/Product-page') 
  },
  {
    path: '/:flower',
    name: 'product',
    component: ()=> import('@/pages/Current-product')
  },
  {
    path: '/oferta',
    name: 'Oferta-page',
    component: ()=> import('@/components/pages/Oferta-page')
  },
  {
    path: '/success',
    name: 'success',
    component: ()=> import('@/components/pages/Success-page')
  },
  {
    path: '/cart',
    name: 'Cart-page',
    component: ()=> import('@/components/pages/Cart-page')
  },
  {
    component:()=> import('@/user/pages/Account-page'),
    name: 'account',
    path: '/account'
  },
  {
    path: '/contacts',
    name: 'contacts',
    component:()=> import('@/components/pages/Contacts-page') 
  },
  {
    path: '/delivery',
    name: 'delivery',
    component:()=> import('@/components/pages/Delivery-page') 
  },
  {
    path: '/news/:current',
    name: 'currentNews',
    component: ()=> import('@/components/pages/Current-news')
},
{
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound,
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior: function(to, from, savedPosition) {
    if (to.hash) {
        return {el: to.hash, behavior: 'smooth'}
    } else {
        return { x: 0, y: 0 }
    }
},
})

export default router
